module.exports = require('./helpers/bundle-url').getBundleURL('gLNYM') + "logo.c51670a8.svg";